<div class="hpanel sticky-team-menu">
  <ul class="panel-body custom-panel pad border-radius-top-left-right-6">
    <li class="navmenu active" (click)="menuclick('home')" [ngClass]="{'active': isChildActive('/teamPage/home')}">
      <a class="navIteam">
        <div class="nav-margin">Home</div>
      </a>
    </li>
    <li class="navmenu active" (click)="menuclick('aboutus')"
      [ngClass]="{'active': isChildActive('/teamPage/aboutus')}">
      <a class="navIteam">
        <div class="nav-margin">About </div>
      </a>
    </li>
    <div class="border-grey ">
      <!-- Label navigates, arrow only toggles. They used to share one handler that did
           both (toggleAndNavigate), so the arrow's expand was thrown away whenever the
           navigation rebuilt this component and Invites Sent could never be reached.
           Same fix as the business page's Employees / Followers menu. -->
      <div class="cursor-ponit ui" [ngClass]="{'active': isChildActive('/teamPage/members')}" (click)="menuclick('members')">

        <div class="cursor-ponit" routerLinkActive="active" > Members
          <span class="join-req" *ngIf="membermenuflag && teamOwnerFlag && pendingCount>0">{{pendingCount}}</span>
        </div>
        <div class="chevron-position" *ngIf="teamOwnerFlag" (click)="toggleSubMenu($event)">
          <svg class="menu-chevron" [class.collapsed]="membermenuflag" width="20px" height="20px" viewBox="0 0 24 24"
            fill="none">
            <rect width="24" height="24" fill="none" />
            <path d="M7 14.5L12 9.5L17 14.5" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
      <!-- Plain CSS transition instead of ngx-bootstrap's [collapse]/[isAnimated]: that
           directive only applies a [collapse] change once its prior 400ms animation
           finishes, so a close click made during the open animation is silently dropped
           until it self-reconciles afterward (same bug fixed in net-navbarpage for My
           Network's Members dropdown). Driving the class off our own `membermenuflag`
           has no such window, and the max-height transition still animates it smoothly. -->
      <div class="custom-panel menu-submenu" [class.menu-submenu-open]="!membermenuflag" *ngIf="teamOwnerFlag">
        <ul id="grouplist" class="list-group cursor-ponit ">
          <ng-container>
            <li class="list-group-item ui line_bw active cursor-ponit b-r-0 no-br"
              [ngClass]="{'active': isChildActive('/teamPage/inviteSent')}" (click)="menuclick('inviteSent')"
              routerLinkActive="active">
              Invites Sent
              <span class="join-req" *ngIf="pendingCount>0 && teamOwnerFlag && !membermenuflag"  style="line-height:15px !important;">{{pendingCount}}</span>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>



    <!-- <div>
      <div class="ty">
        <div class="br-none business-menu-dropdown"
          [ngClass]="{'subactive':menus=='members'}">
          <div class="panel-tools" *ngIf="teamOwnerFlag">
            <a (click)="membermenuflag = !membermenuflag" [attr.aria-expanded]="!membermenuflag">
              <ng-icon name="tablerChevronDown" *ngIf="membermenuflag" (click)="down('down')"></ng-icon>
              <ng-icon name="tablerChevronUp" *ngIf="!membermenuflag" (click)="down('up')"></ng-icon>
            </a>
          </div>
          <div class="cursor-ponit" (click)="menuclick('follower')" routerLinkActive="active"
            [attr.aria-expanded]="!membermenuflag">
            <h5 class="cursor-ponit common-font-12" routerLinkActive="active"> Members
              <span class="join-req" *ngIf="membermenuflag && teamOwnerFlag && pendingCount>0">{{pendingCount}}</span>
            </h5>
          </div>
        </div>
      </div>
      <div class="custom-panel" *ngIf="teamOwnerFlag" [collapse]="membermenuflag"
        [isAnimated]="true">
        <ul id="grouplist" class="list-group cursor-ponit ">
          <ng-container>
            <li class="list-group-item active br-none cursor-ponit"
              [ngClass]="{'subactive':menus=='followerRequestsSent'}"
              (click)="menuclick('inviteSent')" routerLinkActive="router-link-active"
              class="common-font-12"> Invites Sent
              <span class="join-req"
              *ngIf="pendingCount>0 && teamOwnerFlag && !membermenuflag">{{pendingCount}}</span>
            </li>
          </ng-container>
        </ul>
      </div>
    </div> -->


  </ul>
</div>